import { TIMING_MS } from '@/constants/timing';
import type React from 'react';
import { useEffect } from 'react';

export function useAutoResizeGroupingColumn({
  apiRef,
  columnsForDisplay,
  rowGroupingModel,
  delay = TIMING_MS.GRID_AUTOSIZE_DELAY,
}: {
  apiRef: React.MutableRefObject<any>;
  columnsForDisplay: any[];
  rowGroupingModel: any[];
  delay?: number;
}) {
  useEffect(() => {
    if (
      !apiRef.current ||
      !columnsForDisplay.length ||
      rowGroupingModel.length === 0
    ) {
      return;
    }

    const timeoutId = setTimeout(() => {
      const api = apiRef.current;
      if (!api) return;

      try {
        const rootEl = api.rootElementRef?.current as
          | HTMLElement
          | null
          | undefined;
        if (!rootEl || !rootEl.isConnected) {
          return;
        }

        const allColumns = api.getAllColumns?.() ?? [];
        if (!allColumns.length) return;

        const firstColumn = allColumns[0];

        const result = api.autosizeColumns?.({
          columns: [firstColumn.field],
          includeHeaders: true,
        });
        if (
          result &&
          typeof (result as Promise<unknown>).catch === 'function'
        ) {
          (result as Promise<unknown>).catch(() => {
            // ignore grid readiness/unmount races
          });
        }
      } catch {
        // ignore errors from incomplete API state
      }
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [apiRef, columnsForDisplay, rowGroupingModel, delay]);
}
